export default "__VITE_ASSET__CkhXkglo__"